import './SelectShoutoutCategories.scss';

import React, { memo } from 'react';

import {
  ITQShoutoutCategory,
  TQShoutoutCategoryValue,
} from '../../../../../types/tqConnectTypes';
import {
  ITQShoutoutCategoryDetails,
} from '../../../../../types/tqConnectTypes/user';

interface Props {
  shoutoutCategoryList: [TQShoutoutCategoryValue, ITQShoutoutCategory][];
  onCategorySelect: (category: ITQShoutoutCategoryDetails) => void;
}

const SelectShoutoutCategories: React.FC<Props> = ({
  shoutoutCategoryList,
  onCategorySelect,
}) => {
  const handleCategoryClick = (
    key: TQShoutoutCategoryValue,
    shoutoutCategory: ITQShoutoutCategory,
  ) => {
    onCategorySelect({
      id: key,
      name: shoutoutCategory.name,
      logo: shoutoutCategory.logo,
    });
  };

  return (
    <div className="select-shoutout-categories">
      <div className="select-shoutout-categories__grid">
        {shoutoutCategoryList.map(([key, shoutoutCategory]) => (
          <button
            key={key}
            type="button"
            className="select-shoutout-categories__item"
            onClick={() => handleCategoryClick(key, shoutoutCategory)}
            aria-label={shoutoutCategory.name}>
            <span className="select-shoutout-categories__item__emoji">
              {shoutoutCategory.logo}
            </span>
            <span className="select-shoutout-categories__item__label">
              {shoutoutCategory.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(SelectShoutoutCategories);
